module.exports = __webpack_public_path__ + "img/shouyecontent_bg.2bb88247.png";